// extracted by mini-css-extract-plugin
export var container = "_3c-0";
export var error = "_3c-9";
export var label = "_3c-5";
export var light = "_3c-6";
export var md = "_3c-3";
export var sm = "_3c-2";
export var thin = "_3c-8";
export var thinBold = "_3c-7";
export var vertical = "_3c-4";
export var xs = "_3c-1";